<script>
    import {Decimal} from 'decimal.js';

    let oneTroyOunceUsdGold = 1800;

    const zero = new Decimal(0);
    const defaultOunce = new Decimal(1800);

    function getNumber(base, defaultValue) {
        try {
            return new Decimal(base);
        } catch {
            return defaultValue;
        }
    }

    $: onePoundGoldInUsd = getNumber(oneTroyOunceUsdGold, defaultOunce).mul(new Decimal(12));
    let usdValue;
    let wallyUsdValue;
    let winksUsdValue;

 

    function integerDivision(a, b) {
        return {
            quotient: a.divToInt(b),
            remainder: a.mod(b)
        };
    }

    function addToString(baseString, addition) {
        if (baseString === "") {
            return addition;
        } else {
            return `${baseString}, ${addition}`;
        }
    }

    function convert(value, valuePerUnit, topUnit, units) {
        const actualValue = getNumber(value, zero);
        const actualValuePerUnit = valuePerUnit;
        let rawValue = integerDivision(actualValue, actualValuePerUnit);
        let output = "";
        if (!rawValue.quotient.eq(zero)) {
            output = addToString(output, `${rawValue.quotient} ${rawValue.quotient == 1 ? topUnit[0] : topUnit[1]}`);
        }
        let amount = rawValue.remainder;
        let divisor = actualValuePerUnit;
        units.forEach(unit => {
            divisor = divisor.div(new Decimal(unit[0]));
            let rawValue = integerDivision(amount, divisor);
            amount = rawValue.remainder;
            if (!rawValue.quotient.equals(zero)) {
               output = addToString(output, `${rawValue.quotient} ${rawValue.quotient == 1 ? unit[1] : unit[2]}`);
            }
        });
        if (output === "") {
            return `No ${topUnit[1]}`;
        }
        return output;
    }

    function convertUsdToWally(usdAmount, usdPerPoundGold) {
        return convert(usdAmount, usdPerPoundGold, ["Customs Gold Unit", "Customs Gold Units"], [
            [61, "Cupon", "Cupons"],
            [53, "Henc", "Henc"],
            [37, "Tentse", "Tentses"],
            [19, "Benç", "Benç"],
            [7, "Pents", "Pents"],
            [41, "Sence", "Sence"],
        ]);
    }

    function convertUsdToWinks(usdAmount, usdPerPoundGold) {
        return convert(usdAmount, usdPerPoundGold, ["Holiday", "Holidays"], [
            [7, "Kwanza", "Kwanzas"],
            [8, "Hanukkah", "Hanukkahs"],
            [12, "Christmas", "Christmases"],
            [365, "Day", "Days"],
            [52, "Weekend", "Weekends"],
            [15, "Ide", "Ides"],
            [15, "PTO", "PTOs"],
            [3, "Personal", "Personals"]
        ]);
    }

    $: wallyUsdValue = convertUsdToWally(usdValue, onePoundGoldInUsd);
    $: winksUsdValue = convertUsdToWinks(usdValue, onePoundGoldInUsd);
</script>

<main>
    <h1>Currency Conversion</h1>
    <h2>Convert from United States Dollars to other important global currencies</h2>

    <p>One troy ounce of gold currently is worth $<input bind:value={oneTroyOunceUsdGold}>.</p>

    <div>
        $<input bind:value={usdValue}> United States Dollars, at ${onePoundGoldInUsd.toNumber().toLocaleString()} per pound, {usdValue == 1 ? "is" : "are"} worth: 
        <ul>
            <li><b>{wallyUsdValue}</b> in Wallyland</li>
            <li><b>{winksUsdValue}</b> in Winksland</li>
        </ul>
    </div>
</main>

<style>
	main {
		text-align: center;
		padding: 1em;
		max-width: 240px;
		margin: 0 auto;
	}

	h1 {
		color: #ff3e00;
		text-transform: uppercase;
		font-size: 4em;
		font-weight: 100;
	}

    h2 {
		color: #ff3e00;
		font-size: 2em;
		font-weight: 100;
	}

    ul {
        list-style-type: none;
        padding: 0; 
        margin: 0;
    }

	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}
</style>